import React from 'react';
import '../../App.css';
import Location from '../Location';
import Footer from '../Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

function Locations () {
    return (
        <>
            <Location />
            <Footer />
            <ToastContainer />
        </>
    )
}

export default Locations;